<template>
	<button class="sort" @click="sortChange">
		{{ title }}
		<i
			v-if="[descId, ascId].includes(value)"
			:class="[
				'fa fa-long-arrow-up sort__icon',
				{
					'sort__icon--rotate': descId === value,
				},
			]"
		/>
	</button>
</template>
<script>
	export default {
		name: 'SortButton',
		props: {
			value: {
				type: [String, Number],
				default: null,
			},
			descId: {
				type: [String, Number],
				default: null,
			},
			ascId: {
				type: [String, Number],
				default: null,
			},
			title: {
				type: String,
				default: '',
			},
		},
		methods: {
			sortChange() {
				const id =
					this.value === this.descId ? this.ascId : this.descId;
				this.$emit('input', id);
			},
		},
	};
</script>
<style lang="scss" scoped>
	BUTTON {
		.sort {
			display: flex;
			align-items: center;
			color: $font-blue;
			font-size: 0.875rem;
		}

		.sort__icon {
			margin-left: 4px;
		}

		.sort__icon--rotate {
			transform: rotate(180deg);
		}
	}
</style>
